<template>
  <div class="drawTips">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
    <div class="drawTipsBox Center">
      <div class="box">
        <img src="../assets/drawTips.png" class="wid100" alt="">
        <div class="btn">
          <img src="../assets/btn/draw.png" @click="handleClose" alt="">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "drawTips",
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.drawTips{width: 100%; height: 100%; overflow-y: auto; position: absolute; z-index: 9; top:0; left: 0; background: rgba(0,0,0,0.8)}
.drawTips .drawTipsBox{width: 100%; height: 90%;}
.drawTips .box{width: 90%; position: relative;}
.drawTips .btn{position: absolute; bottom: -20%; width: 100%; text-align: center;}
.drawTips .btn img{ width: 55%;}
</style>



// WEBPACK FOOTER //
// src/components/drawTips.vue